<template>
  <transition name="toast">
    <div class="toast">
      <div class="message">{{text}}</div>
      <div class="button" @click="close">知道了</div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    text: ''
  },
  methods: {
    close () {
      window.$app.$emit('closeToast')
    }
  }

}
</script>

<style lang="stylus" scoped>
@import '../css/var'
.toast
  position fixed
  bottom 0
  left 0
  min-width 100%
  width 100%
  min-height pt(96)
  z-index 1000
  padding 0 pt(24)
  background-color rgba(0, 0, 0, 0.8)
  color white
  display flex
  justify-content space-between
  align-items center
  .message
    flex 1 1 auto
    padding-top pt(32)
    padding-bottom pt(32)
    font-size $normal-font-size
  .button
    flex 0 1 auto
    padding-top pt(32)
    padding-bottom pt(32)
    width 4em
    font-size $normal-font-size
    color #31c27c
    

.toast-enter-active,.toast-leave-active
  transition transform .4s cubic-bezier(0.23, 1, 0.32, 1), opacity .4s cubic-bezier(0.445, 0.05, 0.55, 0.95)
  backface-visibility: hidden

.toast-enter,
.toast-leave-active
  transform translate3d(0, 100%, 0);
  opacity 0
</style>



// WEBPACK FOOTER //
// toast.vue?7e1a085e